import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Impressum from "./components/Impressum";

const Home = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <Contact onShowPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
      </main>
      <Footer 
        onShowPrivacyPolicy={() => setShowPrivacyPolicy(true)}
        onShowImpressum={() => setShowImpressum(true)}
        onShowCookieSettings={() => setShowCookieSettings(true)}
      />
      
      {/* DSGVO Components */}
      <CookieBanner 
        forceShow={showCookieSettings}
        onClose={() => setShowCookieSettings(false)}
      />
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
      {showImpressum && (
        <Impressum onClose={() => setShowImpressum(false)} />
      )}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;